module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Bold.fa6f04c.eot";